module.exports = __webpack_public_path__ + "img/logo.e9f8e57d.png";